import { REGEX_FOR_INTEGER_NUMBERS } from '@common/constants/regex';

export const onKeyPressInteger = (e: React.KeyboardEvent) => {
  if (!REGEX_FOR_INTEGER_NUMBERS.test(e.key)) {
    e.preventDefault();
    return false;
  }
};
